import EfBundlesActivity from '@elem/ui/ef-bundles-activity';
import { Fragment, useEffect, useState } from 'react';
import { IPageStatus } from '../../../config/IPageStatus';

export default function TheComp({ isNeedLogin, isLogin, dataA, dataB, pageStatus }: any) {
    const titleList = [
        {
            titleKey: 'itemA',
            title: 'RIVER 3 (230)',
        },
        {
            titleKey: 'itemB',
            title: '+110Wセット',
        },
    ];
    const [selectItem, setSelectItem] = useState(dataA);
    const titleChange = (item: any) => (item.titleKey === 'itemA' ? setSelectItem(dataA) : setSelectItem(dataB));

    useEffect(() => {
        setSelectItem(dataA);
    }, [dataA]);

    return (
        <Fragment key={selectItem.titleKey}>
            <EfBundlesActivity
                {...selectItem}
                titleList={titleList}
                titleChange={titleChange}
                isNeedLogin={isNeedLogin}
                isLogin={isLogin}
                className={`${selectItem.titleKey} ${pageStatus != IPageStatus.statusC ? 'hidden-btn' : ''}`}
            />
        </Fragment>
    );
}
